import { useState } from "react";
import { useEffect } from "react";
import { Autocomplete, TextField, Stack } from "@mui/material";
import { Lista } from "../../App_Catalogo/Transportista/Component";
import AuthContext from "../../../contexts/JWTContext";
import { useContext } from "react";
interface Props {}
export default function Select({}: Props) {
  const context = useContext(AuthContext);
  const [data, setData] = useState([]);
  // const [valorDefecto, setvalorDefecto] = useState({RazonSocial:sessionStorage.getItem('transportistaRazonSocial'),IdTransportista:sessionStorage.getItem('transportista')});

  const valorInicial = {
    RazonSocial: sessionStorage.getItem("transportistaRazonSocial"),
    IdTransportista: sessionStorage.getItem("transportista")
  };

  const sonValoresNull = Object.values(valorInicial).some(
    (valor) => valor === null || valor === "null"
  );

  const [valorDefecto, setValorDefecto] = useState(
    sonValoresNull ? null : valorInicial
  );

  const Name = "ListaTransportista";
  useEffect(() => {
    // setvalorDefecto(JSON.stringify(sessionStorage.getItem('isLoggedIn')));
    Lista({ IdAduana: sessionStorage.getItem("aduana") }, () => {})
      .then((respuesta: any) => {
        if (!respuesta.data.Error) {
          setData(respuesta.data?.Recordset);
        }
      })
      .catch((error) => {});
  }, []);
  useEffect(() => {
    context?.loanding();
    const timeoutId = setTimeout(
      () => {
        context?.Dloanding();
      },
      sessionStorage.getItem("transportista") != null ? 1000 : 100
    );
    // Limpiar el timeout cuando el componente se desmonte
    return () => clearTimeout(timeoutId);
  }, [context?.state.transportista_]);
  const change_select = (newValue: any) => {
    setValorDefecto(newValue);
    context?.SetTrasnportistaForMadulo({
      transportista: newValue != null ? newValue.IdTransportista : null,
      RazonSocial: newValue != null ? newValue.RazonSocial : null
    });
    // hacer el cambio al context
  };
  return (
    <>
      <Stack spacing={1}>
        {/* <InputLabel>Transportista:</InputLabel> */}
        <Autocomplete
          // size="small"
          fullWidth={true}
          freeSolo={false}
          options={data}
          noOptionsText={"No existen coincidencias"}
          limitTags={5}
          value={valorDefecto}
          onChange={(e, newValue: any) => {
            change_select(newValue);
          }}
          filterSelectedOptions={true}
          autoHighlight
          getOptionLabel={(option: any) =>
            " " + option.IdTransportista + " | " + option.RazonSocial.trim()
          }
          filterOptions={(options, { inputValue }) =>
            options.filter(
              (option) =>
                option.RazonSocial.toLowerCase().includes(
                  inputValue.toLowerCase()
                ) ||
                option.IdTransportista.toString()
                  .toLowerCase()
                  .includes(inputValue.toLowerCase())
            )
          }
          // onBlur={onBlur}
          renderOption={(props, option: any) => (
            <li
              {...props}
              style={{ borderBottom: ".3px solid #68676796" }}
              key={option.RFC + option.SCAC + option.UltNumEmbarque}
            >
              {option.IdTransportista + " | " + option.RazonSocial}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} name={Name} placeholder="Transportista" />
          )}
        />
      </Stack>
    </>
  );
}
